import { render } from "./viewServiceInvoice.vue?vue&type=template&id=679607bc"
import script from "./viewServiceInvoice.vue?vue&type=script&lang=js"
export * from "./viewServiceInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__